module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"account-page-header\"> <div class=\"dropdown pull-right\"> <a href=\"#\" class=\"dropdown-btn btn help-dropdown-btn\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"> <img src=\"/assets/images/icons/help.svg\" alt=\"Help Icon\"> Help <span class=\"down-arrow\"></span> </a> <ul class=\"dropdown-menu dropdown-menu-right\"> <li><a href=\"/docs/api\">Documentation</a></li> <li><a href=\"/knowledgebase\">Knowledge Base</a></li> <li><a href=\"/support\">Support</a></li> </ul> </div> <span class=\"title\">")
    ; __append(escapeFn( locals.name ))
    ; __append("</span> ")
    ;  _.each(locals.links, function(link) { 
    ; __append(" <a href=\"")
    ; __append(escapeFn( link.href ))
    ; __append("\" class=\"btn btn-default header-btn hidden-xs\" target=\"_blank\">")
    ; __append(escapeFn( link.name ))
    ; __append("</a> ")
    ;  }); 
    ; __append(" ")
    ;  _.each(locals.subViews, function(subView, idx) { 
    ; __append(" <span id=\"")
    ; __append(escapeFn( locals.computeSubViewID(idx) ))
    ; __append("\"></span> ")
    ;  }); 
    ; __append(" </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/page_header/template.ejs
// module id = 822
// module chunks = 1